<!-- Dialog: QUICK FILL CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <p>{{ data.dialogData.message_text }}</p>
  <p
    class="dialog__body__order-quick-fill-confirm overflow-ellipsis"
    [title]="data.dialogData.message_text_ids"
  >
    {{ data.dialogData.message_text_ids }}
  </p>

  <p-footer>
    <div [hidden]="!data.dialogData.checkbox_show">
      <p-checkbox
        name="stp"
        value="stp"
        class="bfx-checkbox-bold-sm order__dialog__quick-fill-confirm__checkbox"
        [ngClass]="{'order__dialog__quick-fill-confirm__checkbox-label--disabled': data.dialogData.checkbox_disabled, 'order__dialog__quick-fill-confirm__checkbox-label--enabled': !data.dialogData.checkbox_disabled}"
        binary="true"
        [disabled]="data.dialogData.checkbox_disabled"
        [label]="data.dialogData.checkbox_text"
        [(ngModel)]="data.dialogData.checkbox_state"
        (onChange)="onChangeQuickFillConfirm_checkbox()"
      ></p-checkbox>
    </div>
    <span fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <button
        pButton
        type="button"
        class="bfx-button-secondary-subtle"
        (click)="actionQuickFillConfirm_close()"
        label="Close"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="actionQuickFillConfirm_confirm()"
        label="Fill"
      ></button>
    </span>
  </p-footer>
</p-dialog>
